import { supabase } from '@/lib/supabase/client';

export type SearchResult = {
  entity_type: string;
  id: string;
  title: string;
  subtitle: string | null;
  slug: string | null;
  handle: string | null;
  image_url: string | null;
  rank: number;
};

export async function searchAll(query: string, limit = 30): Promise<SearchResult[]> {
  const { data, error } = await supabase
    .rpc('search_all', { query, lim: limit })
    .throwOnError();
  if (error) throw error;
  return (data ?? []) as SearchResult[];
}

export function resultHref(r: SearchResult): string {
  switch (r.entity_type) {
    case 'profile':  return `/profile/${r.handle ?? r.id}`;
    case 'group':    return `/groups/${r.slug ?? r.id}`;
    case 'event':    return `/events/${r.slug ?? r.id}`;
    case 'job':      return `/jobs/${r.slug ?? r.id}`;
    case 'venture':  return `/ventures/${r.slug ?? r.id}`;
    default:         return '/';
  }
}
